const API = '/api/admin'

function getToken() {
  return localStorage.getItem('admin_token')
}

async function request(method, path, body) {
  const token = getToken()
  const headers = { ...(token && { Authorization: `Bearer ${token}` }) }
  if (body !== undefined) headers['Content-Type'] = 'application/json'

  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    ...(body !== undefined && { body: JSON.stringify(body) }),
  })

  if (res.status === 401) {
    localStorage.removeItem('admin_token')
    window.location.replace('/admin/login')
    return
  }

  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`)
  return data
}

export const adminLogin = (login, password) =>
  request('POST', '/login', { login, password })

// Services
export const getServices = () => request('GET', '/services')
export const getService = (id) => request('GET', `/services/${id}`)
export const createService = (data) => request('POST', '/services', data)
export const updateService = (id, data) => request('PUT', `/services/${id}`, data)
export const deleteService = (id) => request('DELETE', `/services/${id}`)
export const reorderServices = (items) => request('PATCH', '/services/reorder', items)

// SubServices
export const getSubServices = (serviceId) =>
  request('GET', `/subservices?serviceId=${serviceId}`)
export const getSubService = (id) => request('GET', `/subservices/${id}`)
export const createSubService = (data) => request('POST', '/subservices', data)
export const updateSubService = (id, data) => request('PUT', `/subservices/${id}`, data)
export const deleteSubService = (id) => request('DELETE', `/subservices/${id}`)
export const reorderSubServices = (items) => request('PATCH', '/subservices/reorder', items)

// Upload
export async function uploadFile(file) {
  const token = getToken()
  const formData = new FormData()
  formData.append('file', file)
  const res = await fetch(`${API}/upload`, {
    method: 'POST',
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    body: formData,
  })
  if (res.status === 401) {
    localStorage.removeItem('admin_token')
    window.location.replace('/admin/login')
    return
  }
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || 'Upload failed')
  return data
}
